module.exports = __webpack_public_path__ + "static/media/icon_ofd.9ea4dcbc.svg";